import { render } from "./LeftNav.vue?vue&type=template&id=65e4acc3&scoped=true"
import script from "./LeftNav.vue?vue&type=script&lang=js"
export * from "./LeftNav.vue?vue&type=script&lang=js"

import "./LeftNav.vue?vue&type=style&index=0&id=65e4acc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e4acc3"]])

export default __exports__